"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuiLayer = void 0;
const UiElements_1 = require("../ui/UiElements");
const BaseLayer_1 = require("./BaseLayer");
const annotationEditor_1 = require("./components/annotationEditor");
const tabNavigation_1 = require("./components/tabNavigation");
const MiniMenu_1 = require("../mini-menu/MiniMenu");
const ViewerOptions_1 = require("../../objects/ViewerOptions");
const ModelTransform_1 = require("../model-transform/ModelTransform");
const Webgl_1 = require("../webgl/Webgl");
const SaveModel_1 = require("../save-model/SaveModel");
const pubsub_js_1 = require("pubsub-js");
const utils_1 = require("../../utils/utils");
class GuiLayer extends BaseLayer_1.BaseLayer {
    constructor(className, hasEditor) {
        super(className);
        this.webgl = Webgl_1.Webgl.getInstance();
        this.container.setId('guiLayer');
        this.hasEditor = hasEditor;
        this.menuCloseBtn = this.createSidebarCloseButton();
        this.container.addChild(this.menuCloseBtn);
        let menu;
        if (ViewerOptions_1.ViewerOptions.viewType === ViewerOptions_1.ViewType.LIGHT || !hasEditor) {
            menu = new MiniMenu_1.MiniMenu();
            this.container.addChild(menu.miniMenuWrapper);
            this.container.addChild(this.createMiniFlexContainer());
            this.menuCloseBtn.domEl.style.color = '#fff';
        }
        else {
            menu = this.createSidebarDiv();
            this.container.addChild(menu);
        }
        (0, pubsub_js_1.subscribe)("background-changed" /* BACKGROUND_CHANGED */, (_, color) => {
            // When 'light' menu is active, color of menu close button must remain white
            if (ViewerOptions_1.ViewerOptions.viewType !== ViewerOptions_1.ViewType.LIGHT) {
                this.menuCloseBtn.domEl.style.color = (0, utils_1.colorBasedOnBackground)(color);
            }
        });
    }
    createMiniFlexContainer() {
        return new UiElements_1.DivEl()
            .setId('flexMiniEmbedLoading');
    }
    // Sidebar
    createSidebarDiv() {
        return new UiElements_1.DivEl()
            .setClass('menu sidebar')
            .setId('sidebar')
            // .addChild(this.createSidebarHeaderDiv())
            .addChild(this.createSidebarTabNavigation())
            .addChild(this.createSidebarContentDiv())
            .addChild(this.createSidebarFooterDiv())
            .addChild(this.createFlexContainer());
    }
    // Sidebar header
    // private createSidebarHeaderDiv(): DivEl {
    //     return new DivEl()
    //         .setClass('sidebar-header')
    //         .setInnerHTML('Test Naslov');
    // }
    createFlexContainer() {
        return new UiElements_1.DivEl()
            .setId('flexEmbedLoading');
    }
    createSidebarCloseButton() {
        return new UiElements_1.ButtonEl()
            .setId('closeMenu')
            .setClass('right-bound top-bound hidden')
            .addAttribute('data-i18n-attr', `data-title=CLOSE_INSPECTOR`)
            .setEvent('click', () => this.closeMenu())
            .addChild(new UiElements_1.IconEl('close'));
    }
    closeMenu() {
        const menuWrapper = document.getElementsByClassName('menu')[0];
        if (!menuWrapper) {
            throw new Error("class menu is undefined. Menu does not exist");
        }
        const closeMenuBtn = document.getElementById('closeMenu');
        closeMenuBtn === null || closeMenuBtn === void 0 ? void 0 : closeMenuBtn.classList.add('hidden');
        menuWrapper.classList.remove('active');
        const menuToggleEl = document.querySelector('#sideToolbar #menuToggler');
        if (!menuToggleEl) {
            return;
        }
        menuToggleEl.classList.remove('active');
    }
    // Sidebar content
    createSidebarContentDiv() {
        return new UiElements_1.DivEl()
            .setClass('sidebar-content')
            .addChild(this.createSidebarTabs());
    }
    // Sidebar footer
    createSidebarFooterDiv() {
        const footer = new UiElements_1.DivEl()
            .setClass('sidebar-footer');
        // .addChild(new DivEl().setId('language'));
        new SaveModel_1.SaveModel(footer.domEl);
        return footer;
    }
    // Sidebar content tabs
    createSidebarTabs() {
        return new UiElements_1.DivEl()
            .setClass('sidebar-tabs')
            .addChild(this.createSidebarTabContent());
    }
    // Tabs navigation
    createSidebarTabNavigation() {
        const tabNavigation = new UiElements_1.DivEl()
            .setId('sidebar-nav-tab')
            .addAttribute('role', 'tablist');
        // TODO: check role
        tabNavigation.addChild((0, tabNavigation_1.createTabNavigationButton)("nav-view" /* NONE */, 'eye', true));
        if (this.hasEditor)
            tabNavigation.addChild((0, tabNavigation_1.createTabNavigationButton)("nav-model" /* MODEL */, '3d'));
        if (this.hasEditor)
            tabNavigation.addChild((0, tabNavigation_1.createTabNavigationButton)("nav-light" /* LIGHT */, 'light'));
        if (this.hasEditor)
            tabNavigation.addChild((0, tabNavigation_1.createTabNavigationButton)("nav-annotation" /* ANNOTATION */, 'annotation'));
        tabNavigation.addChild(new UiElements_1.DivEl().setId('spaceFiller'));
        return new UiElements_1.NavEl().addChild(tabNavigation);
    }
    // Tab panels
    createSidebarTabContent() {
        const tabContent = new UiElements_1.DivEl().setId('nav-tabContent');
        // TODO: check role
        if (true)
            tabContent.addChild(this.createViewPanel());
        if (this.hasEditor)
            tabContent.addChild(this.createModelPanel());
        if (this.hasEditor)
            tabContent.addChild(this.createLightPanel());
        if (this.hasEditor)
            tabContent.addChild(this.createAnnotationPanel());
        return tabContent;
    }
    // View tab panel
    createViewPanel() {
        return new UiElements_1.DivEl()
            .setClass('tab-pane active')
            .setId('nav-view-tab')
            .addAttribute('data-tab-id', 'nav-view')
            .addChild(new UiElements_1.DivEl().setId('viewPosition'))
            .addChild(new UiElements_1.DivEl().setId('measurement'))
            .addChild(new UiElements_1.DivEl().setId('modelQuality'))
            .addChild(new UiElements_1.DivEl().setId('scaleUnit'))
            .addChild(new UiElements_1.DivEl().setId('annotationControl'));
    }
    // Model tab panel
    createModelPanel() {
        const modelTransform = new UiElements_1.DivEl().setId('modelTransform');
        new ModelTransform_1.ModelTransform(this.webgl, modelTransform.domEl);
        return new UiElements_1.DivEl()
            .setClass('tab-pane')
            .setId('nav-model-tab')
            .addAttribute('data-tab-id', 'nav-model')
            .addChild(new UiElements_1.DivEl().setId('general'))
            .addChild(modelTransform)
            .addChild(new UiElements_1.DivEl().setId('background'))
            .addChild(new UiElements_1.DivEl().setId('screenshot'));
    }
    // Light tab panel
    createLightPanel() {
        return new UiElements_1.DivEl()
            .setClass('tab-pane')
            .setId('nav-light-tab')
            .addAttribute('data-tab-id', 'nav-light')
            .addChild(new UiElements_1.DivEl().setId('lightsContainer'));
    }
    // Annotation tab panel
    createAnnotationPanel() {
        return new UiElements_1.DivEl()
            .setClass('tab-pane')
            .addAttribute('data-tab-id', 'nav-annotation')
            .setId('nav-annotation-tab')
            .addChild(new UiElements_1.DivEl().setClass('annotationContainerTitle').addAttribute('data-i18n-key', 'ANNOTATION'))
            .addChild(new UiElements_1.DivEl().setId('annotationAddHint').addAttribute('data-i18n-key', 'ANNOTATION_ADD_HINT'))
            .addChild((0, annotationEditor_1.createAnnotationEditorDiv)())
            .setEvent('dragover', (event) => PubSub.publish("dragover" /* DRAGOVER */, event));
    }
}
exports.GuiLayer = GuiLayer;
